import ContatoRapido from './ContatoRapido';

export default ({data}) => {
    return (
        <>
            <br/><strong>Telefone</strong>: {data?.telephone}{" "}
            <ContatoRapido telefone={data?.telephone} mostrarNumero={false} /><br/>
            <strong>Linkedin</strong>: {data?.linkedin}{" "}
            <ContatoRapido linkedin={data?.linkedin} mostrarNumero={false} /><br/>
            <strong>E-mail</strong>: {data?.email}{" "}
            <ContatoRapido email={data?.email} mostrarNumero={false} /><br/>
            <strong>Cargo</strong>: {data?.cargo}<br/><br/>
        </>
    )
}
